// React
import { memo, useCallback, useState } from "react";

// UI Components
import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";

// Services & API
import { VehicleServicesSearchFormValues } from "services/api/calculations/vehicleservice/types";
import { initialVehicleServicesSearchForm } from "services/api/calculations/vehicleservice/consts";

// Types
import { VehicleServicesSearchFilterProps } from "./types";

// Helpers
import { useTranslate } from "helpers";

const VehicleServicesSearchFilters: React.FC<
  VehicleServicesSearchFilterProps
> = (props) => {
  const { onSearchChange, onAddNew } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<VehicleServicesSearchFormValues>(
    initialVehicleServicesSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialVehicleServicesSearchForm);
  }, []);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 md:mr-6 lg:md-12 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
          <div className="py-3 flex gap-2 justify-end ">
            <Button
              variant="primary"
              children={t("admin.calculation.setting.vehicleservices.add")}
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(VehicleServicesSearchFilters);
